/**
 * Responsive Menu.
 * @format
 */
/* eslint-disable max-len */

import React, { useContext, lazy, Suspense } from 'react';
import { NavigationContext } from '@context/navigation-context';
import { useStateValue } from '@context/state-context';
import {
  NavigationData,
  HdrMainMenuVocab,
} from '@context/navigation-context-modals';
import Loader from '@components/loader';
import { currentlyLoggedIn } from '@services/drupal-services';

const MobileSearch = lazy(
  () =>
    import(
      /* webpackChunkName: "mobile-search" */ '@components/search/mega-menu-search/mobile-search'
    )
);

const ResponsiveSubmenu = lazy(
  () =>
    import(/* webpackChunkName: "responsive-submenu" */ './responsive-submenu')
);

const AuxiliaryNavigation = lazy(
  () =>
    import(
      /* webpackChunkName: "auxiliary-navigation" */ '@components/auxiliary-navigation/auxiliary-navigation'
    )
);

/**
 * Responsive Menu.
 */
const ResponsiveMenu = (): JSX.Element | null => {
  const navigationData: NavigationData = useContext(NavigationContext);
  const { hdr_main_menu_vocab: menuData }: HdrMainMenuVocab[] = navigationData;
  const [{ menuItem, menuTransitioning, openToggle }] = useStateValue();

  /**
   * Classes.
   */
  const { direction, transitioning } = menuTransitioning;
  const openClass = openToggle.menuOpen ? 'open' : '';
  const closingClass = openToggle.closing ? 'closing' : '';
  const activeMainMenu = menuItem.active === -1 ? 'main-active' : '';
  const transitionDirection = transitioning ? `transitioning-${direction}` : '';
  const isLoggedIn = currentlyLoggedIn() ? 'user-logged-in' : '';

  /**
   * Render.
   */
  if (menuData) {
    return (
      <div
        className={`responsive-navigation-wrapper ${openClass} ${closingClass} ${activeMainMenu} ${transitionDirection} ${isLoggedIn}`}>
        <div className="responsive-navigation-outter-container">
          <div className="responsive-navigation-container">
            <Suspense fallback={<Loader />}>
              <MobileSearch />
              <ResponsiveSubmenu
                menuData={menuData}
                parent={-1}
                title={null}
                featured={null}
              />
              <AuxiliaryNavigation location={`responsive-aux-navigation`} />
            </Suspense>
          </div>
        </div>
      </div>
    );
  }
  return null;
};
export default ResponsiveMenu;
